import { isHourIntervalAllowed } from './extendedDosage';

const HOURS_PER_DAY = 24;

const DAY_SPLITTING_HOUR_INTERVALS = [...Array(HOURS_PER_DAY).keys()]
   .map((index) => index + 1)
   .filter(isHourIntervalAllowed);

const getAdjacentMultiple = (value: number, multiplier: number, direction: 1 | -1): number => {
   if (multiplier > 0) {
      const round = direction === 1 ? Math.floor : Math.ceil;

      return (round(value / multiplier) + direction) * multiplier;
   }

   return value + direction;
};

export const getNextMultiple = (value: number, multiplier: number): number => {
   return getAdjacentMultiple(value, multiplier, 1);
};

export const getPreviousMultiple = (value: number, multiplier: number): number => {
   return getAdjacentMultiple(value, multiplier, -1);
};

export const getNextAllowedHourInterval = (hours: number): number => {
   return DAY_SPLITTING_HOUR_INTERVALS.find((interval) => interval > hours) ?? getNextMultiple(hours, HOURS_PER_DAY);
};

export const getPreviousAllowedHourInterval = (hours: number): number => {
   if (hours > HOURS_PER_DAY) {
      return getPreviousMultiple(hours, HOURS_PER_DAY);
   }

   return DAY_SPLITTING_HOUR_INTERVALS.filter((interval) => interval < hours).pop() ?? 0;
};
